import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { generateHTML } from '@tiptap/html';
import { Document } from '@tiptap/extension-document';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
import { Bold } from '@tiptap/extension-bold';
import { Italic } from '@tiptap/extension-italic';
import { Strike } from '@tiptap/extension-strike';
import { Image as NodeImage } from '@tiptap/extension-image';
// @ts-ignore - JS helper without types
import { PlainTextLink } from 'helpers/tiptapLink';
import styles from './styles.module.scss';

interface NewsCardProps {
  imageUrl?: string;
  title: string;
  date: string;
  description?: any;
  to: string;
}

const NewsCard: React.FC<NewsCardProps> = ({ imageUrl, title, date, description, to }) => {
  const descriptionHtml = useMemo(() => {
    if (!description) return '';
    try {
      return generateHTML(description, [
        Document,
        Paragraph,
        Text,
        Bold,
        Italic,
        Strike,
        PlainTextLink,
        NodeImage.configure({
          HTMLAttributes: { class: styles.hideImage },
        }),
      ]);
    } catch {
      return '';
    }
  }, [description]);

  return (
    <Link to={to} className={styles.card}>
      <div className={styles.cardTextContent}>
        <span className={styles.cardDate}>{date}</span>
        <h3 className={styles.cardTitle}>{title}</h3>
        {descriptionHtml && (
          <p
            className={styles.cardDescription}
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        )}
      </div>
      {imageUrl && (
        <div className={styles.cardImageWrapper}>
          <img src={imageUrl} alt={title} className={styles.cardImage} />
        </div>
      )}
    </Link>
  );
};

export default NewsCard;
